import { ReactElement } from 'react';
import { useTranslation } from 'next-i18next';
import Button from '@Hotels-at-Home/hah-fe-core/dist/components/Button';
import { Link } from '@Hotels-at-Home/hah-fe-core/dist/components';
import { IGetPromotionResponse } from '@Hotels-at-Home/hah-fe-core/dist/types';
import BannerWrapper from '@Hotels-at-Home/hah-fe-core/dist/components/BannerWrapper';

interface IProps {
  promotion: IGetPromotionResponse;
}

const HeroSection = ({ promotion }: IProps): ReactElement => {
  const { t } = useTranslation('', { keyPrefix: '$pages.$home.$heroSection' });
  const { t: tButton } = useTranslation('', { keyPrefix: '$common.$buttons' });
  const { t: tLink } = useTranslation('', { keyPrefix: '$local.$homePageLinks.$hero' });

  const promotionIsActive = promotion?.promo_is_active;

  let RenderBanners;

  if (promotionIsActive) {
    RenderBanners = (
      <span className="pattern">
        <BannerWrapper promotion={promotion} />
      </span>
    );
  } else {
    RenderBanners = null;
  }

  return (
    <section className="base-section hero-section main-hp" id="HP_hero_bed">
      <div className="desktop-only">
        <Link href={tLink('bed')} noTabbing noClass>
          <div className="desktop-viewport">
            <div className="cinema-fallback">
              <div className="cinema-graph-gif">
                <div className="cinema-graph-png" />
              </div>
            </div>
            <div className="stack">
              <h1 className="main-section-title">{t('title')}</h1>
              <h2 className="main-section-subtitle">{t('copy')}</h2>
              <Button ariaLabel={`${tButton('shopNow')}: ${t('luxuryCollectionBed')}`}>
                {tButton('shopNow')}
              </Button>
            </div>
            <span className="property">{t('property')}</span>
          </div>
        </Link>
        {!promotionIsActive && (
          <span className="pattern">
            <span className="tagline-span">{t('tagline')}</span>
          </span>
        )}
        {RenderBanners}
      </div>
    </section>
  );
};

export default HeroSection;
